import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { WaveHeightSvgComponent } from './wave-height-legend/wave-height-legend-svg';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';

export const WAVE_HEIGHT_LEGEND: TwcLegendParams = {
  title: 'WAVE HEIGHTS (FORECAST)',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: WaveHeightSvgComponent },
  legendComponent: TwcLegendComponent
};
